import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { customerUserKeys } from './customerUsers.key';
import { useEffect, useState } from 'react';
import { useDebounce } from '../../../features/redListedCompanies/helpers/debounceSearch';

export type SortCustomerUsers =
  | 'firstName_ASC'
  | 'firstName_DESC'
  | 'lastName_ASC'
  | 'lastName_DESC';

export function useGetAllCustomerUsersOnClient(
  clientId: string,
  take?: number,
  skip?: number,
  sort?: SortCustomerUsers,
  search = ''
) {
  const getApi = useApi();
  const [count, setCount] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const debounce = useDebounce();

  useEffect(() => {
    debounce(() => setDebouncedSearch(search), 300);
  }, [search]);

  const getCustomerUsers = async () => {
    const api = await getApi();

    const res = await api.customerUserFindAllOnClient(
      clientId,
      take,
      skip,
      sort,
      debouncedSearch
    );
    setCount(Number(res.headers['x-total-count']));

    return res.data;
  };

  const query = useQuery({
    queryKey: customerUserKeys.findAllOnClient(
      clientId,
      take,
      skip,
      sort,
      debouncedSearch
    ),
    queryFn: getCustomerUsers,
    keepPreviousData: true,
  });

  return {
    ...query,
    count,
  };
}
